import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { useNavigationItems } from '../../../hooks/useNavigationItems';
import useClickOutside from '../../../hooks/useClickOutside';

// Workaround for framer-motion type issue with React 18
const SafeAnimatePresence = AnimatePresence as any;

const MobileNavigation: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const navItems = useNavigationItems();
    const location = useLocation();

    const toggleMenu = () => setIsOpen(!isOpen);

    const menuRef = useClickOutside<HTMLDivElement>(() => setIsOpen(false));

    return (
        <div className="md:hidden" ref={menuRef}>
            <button
                onClick={toggleMenu}
                className="p-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors"
                aria-label="Toggle menu"
            >
                <span className="material-symbols-outlined text-2xl">
                    {isOpen ? 'close' : 'menu'}
                </span>
            </button>


            <SafeAnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: -20, scale: 0.95 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: -20, scale: 0.95 }}
                        transition={{ duration: 0.2 }}
                        className="absolute top-16 right-4 w-56 bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 py-2 z-50"
                    >
                        {navItems.map((item) => {
                            const isActive = location.pathname === item.path;
                            return (
                                <Link
                                    key={item.path}
                                    to={item.path}
                                    data-tour={`nav-${item.path === '/' ? 'dashboard' : item.path === '/integracoes' ? 'integrations' : item.path === '/ia' ? 'ia' : item.path === '/leads-salvos' ? 'leads-salvos' : ''}`}
                                    onClick={() => setIsOpen(false)}
                                    className={`flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors ${isActive
                                        ? 'bg-primary/10 text-primary'
                                        : 'text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700/50'
                                        }`}
                                >
                                    <span className={`material-symbols-outlined ${isActive ? 'text-primary' : 'text-gray-500 dark:text-gray-400'}`}>
                                        {item.icon}
                                    </span>
                                    {item.name}
                                </Link>
                            );
                        })}
                    </motion.div>
                )}
            </SafeAnimatePresence>
        </div>
    );
};

export default MobileNavigation;
